import { createFileRoute } from '@tanstack/react-router';

import { MovementPage, misParams } from '@/features/mis';

export const Route = createFileRoute('/_app/mis/movement')({
  staticData: { crumb: 'nav.movement' },
  component: function Movement() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return <MovementPage params={misParams(search)} onChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true })} />;
  },
});
